import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { AssessmentInfoSlice, createAssessmentInfoSlice } from "./slices/assessmentInfo";
import { ConfigurationInfoSlice, createConfigurationInfoSlice } from "./slices/configurationInfo";
import { createDeviceInfoSlice, DeviceInfoSlice } from "./slices/deviceInfo";
import { createSessionInfoSlice, SessionInfoSlice } from "./slices/sessionInfo";
import { createUserInfoSlice, UserInfoSlice } from "./slices/userInfo";

export type Storage = SessionInfoSlice & UserInfoSlice & ConfigurationInfoSlice;

export type LocalStorage = AssessmentInfoSlice & DeviceInfoSlice;

export const useStore = create<Storage>()(
	persist(
		(...a) => ({
			...createSessionInfoSlice(...a),
			...createUserInfoSlice(...a),
			...createConfigurationInfoSlice(...a),
		}),
		{
			name: "session-storage",
			storage: createJSONStorage(() => sessionStorage),
			partialize: (state) => {
				const { error: _error, ...persistedState } = state;
				return persistedState;
			},
		},
	),
);

export const useLocalStorageStore = create<LocalStorage>()(
	persist(
		(...a) => ({
			...createAssessmentInfoSlice(...a),
			...createDeviceInfoSlice(...a),
		}),
		{
			name: "local-storage",
			storage: createJSONStorage(() => localStorage),
		},
	),
);
